import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import { strings } from 'config/localization';
import React, { useRef } from 'react';

interface AlertProps {
  isOpen: boolean;
  onClose: () => void;
  alertDialogHeader: string;
  alertDialogBody: string;
  isLoading: boolean;
  onDelete: () => void;
}

const Alert: React.FC<AlertProps> = (props) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const {
    isOpen,
    onClose,
    onDelete,
    isLoading = false,
    alertDialogHeader,
    alertDialogBody,
  } = props;

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {alertDialogHeader}
          </AlertDialogHeader>

          <AlertDialogBody>{alertDialogBody}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              {strings.cancel}
            </Button>
            <Button
              colorScheme="red"
              isLoading={isLoading}
              onClick={onDelete}
              ml={3}>
              {strings.delete}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default Alert;
